import clsx from "clsx"
import { FC } from "react"
import { useAppSelector } from "store/index"
import { AppSelectors } from "store/slices/appSlice"
import { isUserInJail } from "store/apis/jailAPI/jail.helpers"
import { useGetMyJailStatusQuery } from "store/apis/jailAPI/jail.api"
import { APP_ROUTES } from "utils/app-routes"
import { FooterMenuItem, IFooterMenuItem } from "./ui/footer-menu-item"
import styles from "./index.module.scss"

const baseItems: Omit<IFooterMenuItem, "disabled">[] = [
  { name: "home", titleKey: "home", url: "/" },
  { name: "hero", titleKey: "hero", url: "/hero/training", startUrl: "/hero" },
  {
    name: "inventory",
    titleKey: "inventory",
    url: "/inventory",
    startUrl: "/inventory"
  },
  {
    name: "wallet",
    id: "btn-wallet",
    titleKey: "wallet",
    url: "/wallet/buy-gold",
    startUrl: "/wallet"
  }
]

const bossPageItems: Omit<IFooterMenuItem, "disabled">[] = [
  { name: "home", titleKey: "home", url: "/" },
  {
    name: "darkHero",
    titleKey: "darkHero",
    url: APP_ROUTES.UNDER.HERO,
    startUrl: "/hero"
  },
  {
    name: "boss",
    titleKey: "bossRoom",
    url: APP_ROUTES.UNDER.BOSS.toString(),
    startUrl: "/boss"
  },
  {
    name: "arena",
    titleKey: "arena",
    url: APP_ROUTES.UNDER.ARENA.toString(),
    startUrl: "/arena"
  },
  {
    name: "wallet",
    id: "btn-wallet",
    titleKey: "wallet",
    url: "/wallet/buy-gold",
    startUrl: "/wallet"
  }
]

export const FooterMenu: FC = () => {
  const isUnder = useAppSelector(AppSelectors.selectIsUnder())
  const { data: jailStatus } = useGetMyJailStatusQuery()
  const jailData = jailStatus?.data
  const userIsInJail = isUserInJail(jailData)

  const disabledInJailItems = ["hero", "inventory"]

  const filteredItems = isUnder ? bossPageItems : baseItems

  const items: IFooterMenuItem[] = filteredItems.map((item) => ({
    ...item,
    url: userIsInJail && item.name === "home" ? "/jail" : item.url,
    disabled: userIsInJail && disabledInJailItems.includes(item.name)
  }))

  return (
    <footer id="footer-menu" className={clsx(styles.FooterMenu)}>
      {items.map((e, i) => (
        <FooterMenuItem {...e} key={i} />
      ))}
    </footer>
  )
}
